import React from 'react'
import { RowLayout } from '../RowLayout'
import { translation } from '../../i18n'
import { CaseTypeType, OtherDataType } from '../../models'
import { OverviewSectionTitle } from './OverviewSectionTitle'

type OtherDataOverviewType = {
  caseType: CaseTypeType | null
  otherData?: OtherDataType
  sectionLabelStyles?: string
} & translation

export const OtherDataOverview = (params: OtherDataOverviewType) => {
  const t = params.t
  return (
    <>
      {params.caseType !== 'TI' && (
        <React.Fragment>
          <OverviewSectionTitle
            styles={params.sectionLabelStyles}
            titleName={t('liabilityForm.title')}
          />
          <RowLayout
            text={params.t('fifthPg.insurance.label')}
            data={params.otherData?.otherInsurance ? t('yes') : t('no')}
          />
          {params.otherData?.otherInsurance === true && (
            <RowLayout
              text={params.t('fifthPg.insuranceCompany.label')}
              data={params.otherData?.otherInsurer}
            />
          )}
          <RowLayout
            text={params.t('fifthPg.card.label')}
            data={params.otherData?.bankCard ? t('yes') : t('no')}
          />
          {params.otherData?.bankCard === true && (
            <RowLayout
              text={params.t('fifthPg.bankName.label')}
              data={params.otherData?.cardIssuer}
            />
          )}
        </React.Fragment>
      )}
      <OverviewSectionTitle
        titleName={t('fifthPg.title2')}
        styles={params.sectionLabelStyles}
      />
      <RowLayout
        text={params.t('fifthPg.bankAccountType.label')}
        data={t(
          `fifthPg.bankAccountType.code.${params.otherData?.bankAccount?.type}`
        )}
      />
      {params.otherData?.bankAccount?.type === 'F' && (
        <React.Fragment>
          <RowLayout
            text={params.t('fifthPg.iban.label')}
            data={params.otherData?.bankAccount?.iban}
          />
          <RowLayout
            text={params.t('fifthPg.swift.label')}
            data={params.otherData?.bankAccount?.bankSwift}
          />
        </React.Fragment>
      )}
      {params.otherData?.bankAccount?.type === 'D' && (
        <RowLayout
          text={params.t('fifthPg.accountNumber.label')}
          data={params.otherData?.bankAccount?.accountNumber}
        />
      )}
      <RowLayout
        text={params.t('fifthPg.holder.label')}
        data={params.otherData?.bankAccount?.accountHolder}
      />
    </>
  )
}
